import { awaitSelector } from '@sitepark/dom-bootstrapper/utils';

awaitSelector('textarea').then(async () => {
	const autosize = (await import('autosize')).default;
	autosize(document.querySelectorAll('textarea'));
});
